"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @param resourceSRN           srn:interwetten:interwetten.at:pixel-manager:container:1:some-user-id
 * @param policySRNPattern      srn:interwetten:interwetten.at:*
 */
const SportradarResourceName_1 = require("../../SportradarResource/SportradarResourceName");
const attributesToCheck = [
    'holdingId',
    'businessEntityId',
    'domainName',
    'resourceType',
    'resourceId',
    'ownerId',
];
function default_1(resourceSRN, policy) {
    try {
        if (isWildcardSymbol(policy)) {
            return true;
        }
        if (!policy.startsWith('srn:')) {
            return false;
        }
        const sportradarResourceName = SportradarResourceName_1.SportradarResourceName.fromString(resourceSRN);
        const policyResourceName = SportradarResourceName_1.SportradarResourceName.fromString(policy);
        // iterate SRN properties
        for (const attributeToCheck of attributesToCheck) {
            const requestedResourceAttribute = sportradarResourceName[attributeToCheck];
            const policyResourceAttribute = policyResourceName[attributeToCheck];
            if (isWildcardSymbol(policyResourceAttribute)) {
                return true;
            }
            let didMatchPattern;
            if (attributeToCheck === 'ownerId') {
                didMatchPattern =
                    requestedResourceAttribute === policyResourceAttribute || matchesGlobalIdentifier(policyResourceAttribute);
            }
            else {
                didMatchPattern =
                    requestedResourceAttribute === policyResourceAttribute ||
                        matchesGlobalIdentifier(requestedResourceAttribute) ||
                        matchesGlobalIdentifier(policyResourceAttribute);
            }
            if (didMatchPattern) {
                // eslint-disable-next-line no-continue
                continue;
            }
            return false;
        }
        return true;
    }
    catch ({ message }) {
        console.error('Error in policy evaluation', { resourceSRN, policySRNPattern: policy, message });
        return false;
    }
}
exports.default = default_1;
function isWildcardSymbol(value) {
    return value === SportradarResourceName_1.SportradarResourceName.wildcardSymbol;
}
function matchesGlobalIdentifier(value) {
    return value === SportradarResourceName_1.SportradarResourceName.globalIdentifier;
}
//# sourceMappingURL=srnMatcher.js.map